export const PATHS = {
  Home: '/',
  Login: '/login',
  Users: '/users',
  Planning: '/',
  weekType: '/week-type',
  Prestations: '/prestations',
  Profile: '/profile',
  notifications: '/notifications',
  intervention: '/interventions',
  Patrimonies: '/patrimonies',
  Help: '/help',
};
